import React, { useEffect, useRef, useState } from 'react';

export default function CursorCrosshair({ containerRef }) {
  const hLineRef = useRef(null);
  const vLineRef = useRef(null);
  const centerRef = useRef(null);
  
  const target = useRef({ x: 0, y: 0 });
  const current = useRef({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const container = containerRef?.current;
    if (!container) return;

    const handleMouseMove = (e) => {
      const rect = container.getBoundingClientRect();
      target.current.x = e.clientX - rect.left;
      target.current.y = e.clientY - rect.top;
      if (!isVisible) setIsVisible(true);
    };
    
    const handleMouseLeave = () => setIsVisible(false);
    const handleMouseEnter = (e) => {
      const rect = container.getBoundingClientRect();
      target.current.x = e.clientX - rect.left;
      target.current.y = e.clientY - rect.top;
      current.current.x = target.current.x;
      current.current.y = target.current.y;
      setIsVisible(true);
    };

    container.addEventListener('mousemove', handleMouseMove);
    container.addEventListener('mouseleave', handleMouseLeave);
    container.addEventListener('mouseenter', handleMouseEnter);

    let animationFrameId;

    const render = () => {
      current.current.x += (target.current.x - current.current.x) * 0.15;
      current.current.y += (target.current.y - current.current.y) * 0.15;

      if (hLineRef.current && vLineRef.current) {
        hLineRef.current.style.transform = `translate3d(${current.current.x}px, ${current.current.y}px, 0) translate(-50%, -50%) rotate(-45deg)`;
        vLineRef.current.style.transform = `translate3d(${current.current.x}px, ${current.current.y}px, 0) translate(-50%, -50%) rotate(45deg)`;
      }

      animationFrameId = requestAnimationFrame(render);
    };

    render();

    return () => {
      container.removeEventListener('mousemove', handleMouseMove);
      container.removeEventListener('mouseleave', handleMouseLeave);
      container.removeEventListener('mouseenter', handleMouseEnter);
      cancelAnimationFrame(animationFrameId);
    };
  }, [containerRef, isVisible]);

  return (
    <div className="cursor-crosshair" style={{ opacity: isVisible ? 1 : 0, transition: 'opacity 0.3s ease' }} aria-hidden="true">
      <div className="cursor-crosshair-d2" ref={vLineRef} />
      <div className="cursor-crosshair-d1" ref={hLineRef}>
        <div className="line-seg" />
        <div className="crosshair-text">
          here for you
        </div>
        <div className="line-seg" />
      </div>
    </div>
  );
}
